export enum LimitedFeature {
	MAP_WIDGET = 'MAP_WIDGET'
}